export default "__VITE_ASSET__WjTj8lzj__"